<template>
    <div class="dashboard-wrapper">
        <div class="sidebar">
            <div class="brand">
                <img src="@/assets/logo_2.png" alt="">
            </div>

            <div class="navs">
                <ul>
                    <li class="nav-item" :class="{'active': $route.meta.title == 'home'}">
                        <router-link :to="{name: 'dashboard-home'}">
                            <div class="nav-item_icon">
                                <span class="fe-home"></span>
                            </div>
                            <div class="nav-item_text">Dashboard</div>
                        </router-link>
                    </li>
                    <!-- <li class="nav-item" :class="{'active': $route.meta.title == 'schedule'}">
                        <router-link :to="{name: 'dashboard-schedule'}">
                            <div class="nav-item_icon">
                                <span class="fe-clock"></span>
                            </div>
                            <div class="nav-item_text">Schedule</div>
                        </router-link>
                    </li> -->
                    <li class="nav-item" :class="{'active': $route.meta.title == 'message'}">
                        <router-link :to="{name: 'dashboard-message'}">
                            <div class="nav-item_icon">
                                <span class="fe-play"></span>
                            </div>
                            <div class="nav-item_text">Messages</div>
                        </router-link>
                    </li>
                    <li class="nav-item" :class="{'active': $route.meta.title == 'settings'}">
                        <router-link :to="{name: 'dashboard-settings'}">
                            <div class="nav-item_icon">
                                <span class="fe-settings"></span>
                            </div>
                            <div class="nav-item_text">Settings</div>
                        </router-link>
                    </li>
                    <li class="nav-item" @click="logout">
                        <div class="nav-item_icon">
                            <span class="fe-power"></span>
                        </div>
                        <div class="nav-item_text">Logout</div>
                    </li>
                </ul>
            </div>
        </div>

        <vue-custom-scrollbar class="mobile-sidebar show-sm-only" 
            :class="{hide: hidesidebar, show: !hidesidebar}" >
            <div  @click="hidesidebar = true">
                <div class="close">
                    <span class="fe-x"></span>
                </div>
                <div class="brand">
                    <img src="@/assets/logo_2.png" alt="">
                </div>

                <div class="navs">
                    <ul>
                        <li class="nav-item" :class="{'active': $route.meta.title == 'home'}">
                            <router-link :to="{name: 'dashboard-home'}">
                                <div class="nav-item_icon">
                                    <span class="fe-home"></span>
                                </div>
                                <div class="nav-item_text">Dashboard</div>
                            </router-link>
                        </li>
                        <li class="nav-item" :class="{'active': $route.meta.title == 'schedule'}">
                            <router-link :to="{name: 'dashboard-schedule'}">
                                <div class="nav-item_icon">
                                    <span class="fe-clock"></span>
                                </div>
                                <div class="nav-item_text">Schedule</div>
                            </router-link>
                        </li>
                        <li class="nav-item" :class="{'active': $route.meta.title == 'message'}">
                            <router-link :to="{name: 'dashboard-message'}">
                                <div class="nav-item_icon">
                                    <span class="fe-play"></span>
                                </div>
                                <div class="nav-item_text">Messages</div>
                            </router-link>
                        </li>
                        <li class="nav-item" :class="{'active': $route.meta.title == 'settings'}">
                            <router-link :to="{name: 'dashboard-settings'}">
                                <div class="nav-item_icon">
                                    <span class="fe-settings"></span>
                                </div>
                                <div class="nav-item_text">Settings</div>
                            </router-link>
                        </li>
                        <li class="nav-item" @click="logout">
                            <div class="nav-item_icon">
                                <span class="fe-power"></span>
                            </div>
                            <div class="nav-item_text">Logout</div>
                        </li>
                    </ul>
                </div>
            </div>
        </vue-custom-scrollbar>

        <div class="main-wrapper">
            <div class="menu show-sm-only" @click="hidesidebar = false">
                    <span class="fe-menu"></span>
            </div>
            <div class="navbar">
                <div class="theme">Leaders Camp 2020</div>
                <div class="name hide-sm">
                    <span>{{role}} </span>
                    <span class="d-inline-block">{{user.firstname}} </span>
                    <span class="ml-2 show-lg-only">{{user.middlename}} </span>
                    <span class="ml-2 show-md">{{user.lastname}}</span>
                </div>
            </div>

            <div class="main-container">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import vueCustomScrollbar from 'vue-custom-scrollbar'

    export default {
        components: {
            vueCustomScrollbar
        },
        data(){
            return {
                hidesidebar: true
            }
        },
        computed: {
            ...mapGetters({user:'USER', role: 'ROLE'})
        },
        methods: {
            logout(){
                this.$store.commit('LOGOUT')
                this.$router.push({name: 'login'})
            }
        },
        created(){

        }
    }
</script>

<style lang="scss" scoped>
    .dashboard-wrapper{
        display: flex;
        background-color: rgb(255, 255, 193);
        height: 100vh;
        overflow: hidden;
    }

    .sidebar, .mobile-sidebar{
        width: 90px;
        height: 92vh;
        background-color: #15215b;
        border-top-right-radius: 50px;
        padding-top: 30px;
        margin-top: 8vh;

        .navs{
            margin-top: 30px;
            ul{
                padding: 0;
                li{
                    list-style: none;
                    color: white;
                    font-size: 14px;
                    text-align: center;
                    a{
                        color: white;
                        text-decoration: none;
                    }
                }
                .nav-item{
                    padding: 20px 0 20px 0;
                    font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif ;
                    border-bottom: 1px solid #111b49;
                    cursor: pointer;
                    &.active{
                        background-color: rgba(255, 255, 255, 0.959);
                        a{
                            color:#15215b;
                        }
                    }
                    &_icon{
                        margin-bottom: 10px;
                        span{
                            font-size: 25px;
                        }
                    }
                }
            }
        }
    }

    .mobile-sidebar{
        margin-top: 0;
        height: 100%;
        overflow-y: scroll;
        overflow-x: hidden;
        position: absolute;
        z-index: 999;
        &.show{
            left: 0;
            transition: all .3s ease-in-out;
        }
        &.hide{
            left: -100px;
            transition: all .3s ease-in-out;
        }
        .brand{
            margin-top: 0px;
            width: 60px;
        }
        .close{
            display: none;
            width: 100%;
            text-align: center;
            span{
                font-size: 30px;
                color: white
            }
        }
    }

    .brand{
        width: 80px;
        margin: 0 auto;
        img{
            width: 100%;
        }
    }
    
    .main-wrapper{
        width: calc(100% - 91px);
        height: 100vh;
        background-color: rgb(255, 255, 193);
        overflow: hidden;
    }

    .main-container{
    }

    .navbar{
        height: 75px;
        width: 80%;
        background-color: rgb(255, 115, 0);
        margin-left: auto;
        border-bottom-left-radius: 50px;
        // border: 2px solid rgb(161, 161, 118);
        border-top: none;
        border-right: none;
        float: right;
        overflow: hidden;
        margin-bottom: 30px;
        .theme{
            float: left;
            margin-left: 40px;
            line-height: 60px;
            font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif ;
            font-size: 25px;
            color: yellow;
        }
        .name{
            float: right;
            line-height: 60px;
            margin-right: 20px;
            font-size: 18px;
            font-family: Arial;
            color:yellow;
        }
    }

    .menu{
        float: left;
        padding: 20px 10px;
        span{
            font-size: 29px;
            color: orangered
        }
    }
</style>